import { postBiz, rows, json } from '../core/coreapi';

export const normalizeTaskProgress = (r: any) => ({
  id: r.id ?? r.rid,
  rid: r.rid,
  api: r.api,
  pid: r.pid,
  pdc: r.pdc ?? '',
  pdn: r.pdn ?? '',
  cyi: r.cyi,
  cyc: r.cyc ?? '',
  cyn: r.cyn ?? '',
  ati: r.ati,
  atc: r.atc ?? '',
  atn: r.atn ?? '',
  tki: r.tki,
  tkc: r.tkc ?? '',
  tkn: r.tkn ?? '',
  cci: r.cci,
  ccc: r.ccc ?? '',
  ccn: r.ccn ?? '',
  loi: r.loi,
  loc: r.loc ?? '',
  lon: r.lon ?? '',
  rmi: r.rmi,
  rmc: r.rmc ?? '',
  rmn: r.rmn ?? '',
  soi: r.soi,
  soc: r.soc ?? '',
  son: r.son ?? '',
  ssi: r.ssi,
  ssc: r.ssc ?? '',
  ssn: r.ssn ?? '',
  pgd: r.pgd ?? '',
  rpr: Number(r.rpr ?? 0),
  apr: Number(r.apr ?? 0),
  rpi: r.rpi,
  rpn: r.rpn ?? '',
  api2: r.api2,
  apn: r.apn ?? '',
  ttl: r.ttl ?? '',
  sum: r.sum ?? '',
  con: r.con ?? '',
  nxt: r.nxt ?? '',
  rmk: r.rmk ?? '',
  dcd: r.dcd ?? '',
  exi: r.exi ?? {},
  sts: r.sts ?? 1,
  ast: r.ast ?? 1,
  stp: r.stp,
  raw: r,

  pam: Number(r.pam ?? r.plannedamount ?? 0),
  cma: Number(r.cma ?? r.committedamount ?? 0),
  iva: Number(r.iva ?? r.invoicedamount ?? 0),
  pda: Number(r.pda ?? r.paidamount ?? 0),
  aca: Number(r.aca ?? r.actualamount ?? 0),
  fpr: Number(r.fpr ?? 0),
  evc: Number(r.evc ?? r.evidencecount ?? 0),
  apc: Number(r.apc ?? r.approvalcount ?? 0),
});

export const fetchTaskProgress = async (params: any = {}) =>
  rows(await postBiz({
    s: 'taskprogress',
    a: 'find',
    pid: params.periodid ?? null,
    cyi: params.cycleid ?? null,
    ati: params.activityid ?? null,
    tki: params.taskid ?? null,
    cci: params.costcenterid ?? null,
    loi: params.locationid ?? null,
    sts: params.status ?? 1,
    src: params.search ?? null,
    pgo: params.pageoffset ?? 0,
    pgl: params.pagelimit ?? 50,
  })).map(normalizeTaskProgress);

export const addTaskProgress = async (payload: any) =>
  json(await postBiz({ s: 'taskprogress', a: 'add', ...payload }));

export const editTaskProgress = async (payload: any) =>
  json(await postBiz({ s: 'taskprogress', a: 'edit', ...payload }));

export const deleteTaskProgress = async (rid: number, stp: string) =>
  json(await postBiz({ s: 'taskprogress', a: 'delete', rid, stp }));


// Approvals and Evidence

export const normalizeProgressApproval = (r: any) => ({
  id: r.id ?? r.rid,
  rid: r.rid,
  tpi: r.tpi,
  vri: r.vri,
  vrc: r.vrc ?? '',
  vrn: r.vrn ?? '',
  ssi: r.ssi,
  ssc: r.ssc ?? '',
  ssn: r.ssn ?? '',
  apl: Number(r.apl ?? 1),
  rvr: Number(r.rvr ?? 0),
  apd: Number(r.apd ?? 0),
  rvi: r.rvi,
  rvn: r.rvn ?? '',
  rvd: r.rvd ?? '',
  dcn: r.dcn ?? '',
  dno: r.dno ?? '',
  dcd: r.dcd ?? '',
  exi: r.exi ?? {},
  sts: r.sts ?? 1,
  ast: r.ast ?? 1,
  stp: r.stp,
  raw: r,
});

export const normalizeProgressEvidence = (r: any) => ({
  id: r.id ?? r.rid,
  rid: r.rid,
  tpi: r.tpi,
  eti: r.eti,
  etc: r.etc ?? '',
  etn: r.etn ?? '',
  fid: r.fid,
  fno: r.fno ?? '',
  fnm: r.fnm ?? '',
  fin: r.fin ?? {},
  fdt: r.fdt ?? {},
  evd: r.evd ?? '',
  cpi: r.cpi,
  cpn: r.cpn ?? '',
  lat: r.lat,
  lng: r.lng,
  rmk: r.rmk ?? '',
  dcd: r.dcd ?? '',
  exi: r.exi ?? {},
  sts: r.sts ?? 1,
  ast: r.ast ?? 1,
  stp: r.stp,
  raw: r,
});

export const fetchProgressApprovals = async (taskprogressid: number) =>
  rows(await postBiz({
    s: 'progressapproval',
    a: 'find',
    tpi: taskprogressid,
    vri: null,
    ssi: null,
    dcn: null,
    sts: 1,
    pgo: 0,
    pgl: 100,
  })).map(normalizeProgressApproval);

export const addProgressApproval = async (payload: any) =>
  json(await postBiz({ s: 'progressapproval', a: 'add', ...payload }));

export const editProgressApproval = async (payload: any) =>
  json(await postBiz({ s: 'progressapproval', a: 'edit', ...payload }));

export const deleteProgressApproval = async (rid: number, stp: string) =>
  json(await postBiz({ s: 'progressapproval', a: 'delete', rid, stp }));

export const fetchProgressEvidence = async (taskprogressid: number) =>
  rows(await postBiz({
    s: 'progressevidence',
    a: 'find',
    tpi: taskprogressid,
    eti: null,
    sts: 1,
    pgo: 0,
    pgl: 100,
  })).map(normalizeProgressEvidence);

export const addProgressEvidence = async (payload: any) =>
  json(await postBiz({ s: 'progressevidence', a: 'add', ...payload }));

export const editProgressEvidence = async (payload: any) =>
  json(await postBiz({ s: 'progressevidence', a: 'edit', ...payload }));

export const deleteProgressEvidence = async (rid: number, stp: string) =>
  json(await postBiz({ s: 'progressevidence', a: 'delete', rid, stp }));


//
export const normalizeTaskPlanning = (r: any) => ({
  id: `${r.api}-${r.tki}`,
  rid: undefined,
  api: r.api,
  pid: r.pid,
  pdc: r.pdc ?? '',
  pdn: r.pdn ?? '',
  cyi: r.cyi,
  cyc: r.cyc ?? '',
  cyn: r.cyn ?? '',
  ati: r.ati,
  atc: r.atc ?? '',
  atn: r.atn ?? '',
  tki: r.tki,
  tkc: r.tkc ?? '',
  tkn: r.tkn ?? '',
  cci: r.cci,
  ccc: r.ccc ?? '',
  ccn: r.ccn ?? '',
  loi: r.loi,
  loc: r.loc ?? '',
  lon: r.lon ?? '',
  rmi: 1,
  rmc: 'SELF',
  rmn: 'Self Reporting',
  soi: 1,
  soc: 'MANUAL',
  son: 'Manual',
  ssi: 1,
  ssc: 'DRAFT',
  ssn: 'Draft',
  pgd: new Date().toISOString().slice(0, 10),
  rpr: 0,
  apr: 0,
  ttl: '',
  sum: '',
  con: '',
  nxt: '',
  rmk: '',
  dcd: '',
  exi: {},
  sts: r.sts ?? 1,
  ast: r.sts ?? 1,
  stp: r.stp,
  raw: r,
  isplanned: true,

  pam: Number(r.pam ?? r.plannedamount ?? 0),
  cma: Number(r.cma ?? r.committedamount ?? 0),
  iva: Number(r.iva ?? r.invoicedamount ?? 0),
  pda: Number(r.pda ?? r.paidamount ?? 0),
  aca: Number(r.aca ?? r.actualamount ?? 0),
  fpr: Number(r.fpr ?? 0),
  evc: Number(r.evc ?? r.evidencecount ?? 0),
  apc: Number(r.apc ?? r.approvalcount ?? 0),
});

export const fetchTaskPlanning = async (params: any = {}) =>
  rows(await postBiz({
    s: 'taskplanning',
    a: 'find',
    pid: params.periodid ?? null,
    cyi: params.cycleid ?? null,
    ati: params.activityid ?? null,
    tki: params.taskid ?? null,
    cci: params.costcenterid ?? null,
    loi: params.locationid ?? null,
    sts: params.status ?? 1,
    src: params.search ?? null,
    pgo: params.pageoffset ?? 0,
    pgl: params.pagelimit ?? 200,
  })).map(normalizeTaskPlanning);


// task action

export const normalizeTaskAction = (r: any) => ({
  id: r.id ?? r.rid,
  rid: r.rid,
  rix: r.rix,

  tpi: r.tpi,
  api: r.api,
  tki: r.tki,
  tkc: r.tkc ?? '',
  tkn: r.tkn ?? '',
  ati: r.ati,
  atc: r.atc ?? '',
  atn: r.atn ?? '',

  acn: r.acn ?? '',

  fsi: r.fsi,
  fsc: r.fsc ?? '',
  fsn: r.fsn ?? '',

  tsi: r.tsi,
  tsc: r.tsc ?? '',
  tsn: r.tsn ?? '',

  aci: r.aci,
  acm: r.acm ?? '',

  tui: r.tui,
  tun: r.tun ?? '',

  acd: r.acd ?? '',
  nts: r.nts ?? '',

  dcd: r.dcd ?? '',
  exi: r.exi ?? {},
  sts: r.sts ?? 1,
  ast: r.ast ?? 1,
  stp: r.stp,
  raw: r,
});

export const fetchTaskActions = async (taskprogressid: number) =>
  rows(await postBiz({
    s: 'taskaction',
    a: 'find',
    tpi: taskprogressid,
    acn: null,
    aci: null,
    tui: null,
    sts: 1,
    pgo: 0,
    pgl: 100,
  })).map(normalizeTaskAction);

export const applyTaskAction = async (payload: any) =>
  json(await postBiz({
    s: 'taskaction',
    a: 'apply',
    ...payload,
  }));

//import { postBiz, rows } from '../core/coreapi';

export const normalizeTimeline = (r:any)=>({
    rid:r.rid,
    tpi:r.tpi,
    evt:r.evt,
    evd:r.evd,
    usi:r.usi,
    usn:r.usn,
    ttl:r.ttl,
    dsc:r.dsc,
    exi:r.exi||{},
    sts:r.sts,
    raw:r
});

export const fetchTaskTimeline = async(taskprogressid:number)=>
rows(await postBiz({
    s:'tasktimeline',
    a:'find',
    tpi:taskprogressid,
    evt:null,
    sts:1,
    pgo:0,
    pgl:500
})).map(normalizeTimeline);